import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { InteractService, CommonUtilty, ComponentOutputDO, ArrayManipulations, ClientService, AppMetadataHandler } from 'app';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { from } from 'rxjs';
import { take, takeWhile } from 'rxjs/operators';


export interface AgentList {
    selectedClientData,
    fetchedClientData,
    targetRoleCd?
}

interface ValidationOutput {
    isInvalid: boolean,
    errorDOs: Array<ErrorDO>
}


export interface EmitterObject {
    role,
    agentList
}
@Component({
    selector: 'app-captured-agent-list',
    templateUrl: './captured-agent-list.component.html',
    styleUrls: ['./captured-agent-list.component.scss']
})
export class CapturedAgentListComponent implements OnInit {
    _currentComponentName = 'CapturedAgentListComponent'

    formatterPercent = value => `${value} %`;
    parserPercent = value => value.replace(' %', '');

    constructor(private viewContainerRef: ViewContainerRef,
        private interactService: InteractService,
        private commonUtilty: CommonUtilty,
        private clientService: ClientService,
        private arrayManipulations: ArrayManipulations,
        private policyService: PolicyService,
        public appMetadataHandler: AppMetadataHandler) { }

    ngOnInit() {

        this.agentZeroState = {
            title: `No ${this.captureRole} selected`,
            message: `No ${this.captureRole} was found for this case.`,
            icon: null
        }
        this.subscribeToParentEvent();
        this.subscribeToCapturedAgentList();
    }

    @Input() captureRole: String;
    @Input() transactionState: string
    @Output() componentOutput = new EventEmitter<any>();
    @Output() openModal = new EventEmitter<any>();

    private _agentList: AgentList;
    @Input() set agentList(value: AgentList) {
        if (value == null || (Array.isArray(value) && value.length == 0))

            this._agentList = { selectedClientData: [], fetchedClientData: [] }
        else {
            this._agentList = value;
        }
    }

    get agentList(): AgentList {
        return this._agentList;
    }

    set additonalAgents(value) {
        if (value == null || (Array.isArray(value) && value.length == 0))

            this._agentList = { selectedClientData: [], fetchedClientData: [] }
        else {
            // this._agentList.selectedClientData.push(...value.selectedClientData);
            // this._agentList.fetchedClientData.push(...value.fetchedClientData);
            let uniqueSelectedClientData = this.arrayManipulations.getUniqueElements(value.selectedClientData, 'clientRefGuid')
            let uniqueFetchedClientData = this.arrayManipulations.getUniqueElements(value.fetchedClientData, 'guid')
            this.agentList = { selectedClientData: uniqueSelectedClientData, fetchedClientData: uniqueFetchedClientData }
        }
    }


    @Input() set inputDataForEdit(value: any) {
        if (value) {
            var agentNumList = []
            for (const key in value) {
                if (value.hasOwnProperty(key)) {

                    if (Array.isArray(value[key]) && value[key].length > 0) {
                        value[key].forEach(item => {
                            agentNumList.push(item)
                        });
                    }

                }
            }
            if (agentNumList && agentNumList.length && agentNumList.length > 0) {

                var clientDO = [];
                agentNumList.forEach(agentObj => {
                    agentObj.clientDO.forEach(clientDOObj => {
                        clientDO.push(clientDOObj);
                    });
                })
                let selectedClientData = this.commonUtilty.mapperToCreateAgentList(clientDO)
                let fetchedClientData = [];
                if (clientDO && clientDO.length && clientDO.length > 0) {
                    clientDO.forEach(obj => {
                        fetchedClientData.push(obj.clientDO);
                    })
                    let agentObj = { selectedClientData: selectedClientData, fetchedClientData: fetchedClientData }
                    this.additonalAgents = agentObj;
                }

            }

        }
    }

    getAgentList$
    policyAgentMap = {}
    fetchingProposalIOs = null
    policyListPreviousData = []

    agentZeroState = {
        title: null,
        message: null,
        icon: null
    }


    EmitOpenSearchModal() {
        this.openModal.emit(false);
    }

    parentEvent$
    subscribeToParentEvent() {
        if (this.parentEvent$ != null)
            this.parentEvent$.unsubscribe()
        this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
            const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
            if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
                // let validationResult = this.validateOutput(this.agentList)
                // if (!validationResult.isInvalid) {
                    let output: EmitterObject = { role: "AGENT", agentList: this.agentList || [] }
                    this.EmitComponentOutput(output)
                // }
            }
            else {
                console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
            }
        })
    }

    getParentComponentName(): Component {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
        } catch { }
    }
    getCurrentComponentName(): string {
        return this._currentComponentName
    }

    EmitComponentOutput(data) {
        let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput);
        console.log("captured agent list emitted data to parent", c);
    }

    validateOutput(o) {

        let validationOutput: ValidationOutput = {
            isInvalid: null,
            errorDOs: []
        }
        validationOutput.errorDOs = this.checkCommmissionPercentage(o, validationOutput.errorDOs);
        if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
            validationOutput.isInvalid = true;
        }
        else {
            validationOutput.isInvalid = false;
        }
        return validationOutput
    }

    subscribeToCapturedAgentList() {
        this.interactService.selectedAgentsListSubject$.subscribe(res => {
            console.log("captured agent list", JSON.stringify(res));
            this.inputDataForNewAgent = res.clientDO
        })
    }

    set inputDataForNewAgent(clientDO) {
        if (Array.isArray(clientDO) && clientDO.length > 0) {
            let selectedClientData = this.commonUtilty.mapperToCreateAgentList(clientDO)
            let fetchedClientData = [];
            clientDO.forEach(obj => {
                fetchedClientData.push(obj.clientDO);
            })
            let agentObj = { selectedClientData: selectedClientData, fetchedClientData: fetchedClientData }
            this.additonalAgents = agentObj;
            // this.agentList['selectedClientData'].push(...selectedClientData)
            // this.agentList['fetchedClientData'].push(...fetchedClientData)
        }
        console.log("unique agents list", JSON.stringify(this.additonalAgents));
        console.log("captured agent list", JSON.stringify(this.agentList));
    }

    checkCommmissionPercentage(agentList, errorDOs) {
        let totalCommissionPercentage = [];
        if (agentList && agentList['selectedClientData'] && agentList['selectedClientData'].length > 0) {
            agentList.selectedClientData.forEach(agentData => {
                totalCommissionPercentage.push(agentData.commissionPercent);
            });
        }

        if (totalCommissionPercentage && totalCommissionPercentage.length && totalCommissionPercentage.length > 0) {
            const totalCommission = totalCommissionPercentage.reduce((tot, curVal) => {
                return tot + curVal;
            })


            if (totalCommission > 100 || totalCommission < 100) {
                let errorDO = new ErrorDO();
                errorDO.fieldNameDescription = "Commission Percentage"
                errorDO.errorMsg = "Total of Commission Percentages should be 100% for Intermediary"
                errorDO.componentName = this.getCurrentComponentName();
                errorDOs.push(errorDO)
            }
            return errorDOs
        }
    }


    removeAgent(guid) {
        console.log("agent list for removing", JSON.stringify(this.agentList));
        if (this.agentList && this.agentList.selectedClientData && this.agentList.selectedClientData.length && this.agentList.selectedClientData.length > 0) {
            this.agentList.selectedClientData.forEach((agentObj, i) => {
                if (guid === agentObj.guid)
                    this.agentList.selectedClientData.splice(i, 1)
            });
        }

        if (this.agentList && this.agentList.fetchedClientData && this.agentList.fetchedClientData.length && this.agentList.fetchedClientData.length > 0) {
            this.agentList.fetchedClientData.forEach((agentObj, i) => {
                if (guid === agentObj.guid)
                    this.agentList.fetchedClientData.splice(i, 1)
            });
        }
    }
}


